var map = {
	"./front/inquiry/InquiryForm": 6554,
	"./front/inquiry/InquiryForm.tsx": 6554,
	"components/front/inquiry/InquiryForm": 6554,
	"components/front/inquiry/InquiryForm.tsx": 6554
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62659;